import React from 'react';

interface BadgeShowcaseProps {
  children: React.ReactNode;
}

const BadgeShowcase: React.FC<BadgeShowcaseProps> = ({ children }) => {
  return (
    <section className="container mx-auto px-6 md:px-16">
      <div className="flex-col items-center justify-center p-5 bg-white rounded-xl shadow-lg md:w-64 mx-auto hidden lg:flex">
        {React.Children.map(children, (child, index) => (
          <div key={index} className="mb-4 last:mb-0">
            {child}
          </div>
        ))}
      </div>
    </section>
  );
};

export default BadgeShowcase;
